<template>
    <div
        ref="rootEl"
        class="akinshino-map-select-app"
    >
        <MainView />
    </div>
</template>

<script setup lang="ts">
    import { onBeforeUnmount, onMounted, ref } from 'vue';
    import MainView from './views/MainView.vue';
    import { landPlotStore } from './store/modules/LandPLot';
    import { cardSettingsStore } from './store/modules/CardSettings';

    const rootEl = ref<null | HTMLElement>(null);

    onMounted(() => {
        window.addEventListener('resize', () => {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        });

        cardSettingsStore.SET_MAP_DOM_RECT(
            rootEl.value!.getBoundingClientRect(),
        );

        if (rootEl.value) {
            window.addEventListener(
                'resize',
                () =>
                    rootEl.value &&
                    cardSettingsStore.SET_MAP_DOM_RECT(
                        rootEl.value.getBoundingClientRect(),
                    ),
            );
            window.addEventListener(
                'scroll',
                () =>
                    rootEl.value &&
                    cardSettingsStore.SET_MAP_DOM_RECT(
                        rootEl.value.getBoundingClientRect(),
                    ),
            );
        }

        window.addEventListener('clickFromTilda', () => {
            landPlotStore.SET_CURRENT_SECTION_ZONE('southwest');
        });
    });

    onBeforeUnmount(() => {
        window.removeEventListener('resize', () => {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        });

        window.removeEventListener(
            'resize',
            () =>
                rootEl.value &&
                cardSettingsStore.SET_MAP_DOM_RECT(
                    rootEl.value.getBoundingClientRect(),
                ),
        );
        window.removeEventListener(
            'scroll',
            () =>
                rootEl.value &&
                cardSettingsStore.SET_MAP_DOM_RECT(
                    rootEl.value.getBoundingClientRect(),
                ),
        );

        window.removeEventListener('clickFromTilda', () => {
            landPlotStore.SET_CURRENT_SECTION_ZONE('southwest');
        });
    });
</script>

<style lang="less">
    @import '~@/assets/styles/reset-prod.less';
    @import '~@/assets/styles/font-face.less';
    @import '~@/assets/styles/utils/fonts-styles.less';
    @import '~@/assets/styles/global-classes.less';

    .akinshino-map-select-app {
        min-width: @size-mobile-bottom;
        color: @dark;
        margin: 0;
        font-family: 'Lato', sans-serif;
    }
</style>
